import vue from 'vue';

vue.filter('decimalPrice', (value, decimal = true) => {
  if (!value) return decimal ? '0,00' : '0';
  const number = value.toString().slice(0, -2) || '0';
  const decimalPart = ('0' + value).toString().slice(-2);
  return number + (decimal ? ',' + decimalPart : '');
});



// WEBPACK FOOTER //
// ./src/filters/decimal-price.filter.js